/* eslint-enable */
/* eslint-enable */

class AnimationExQuotes {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleExQuotes = this.sectionsContainer.querySelectorAll('.ex-quotes');
		
		if (!this.$moduleExQuotes.length)
			return;
		
		this.$moduleExQuotesElements = [];

		this.$moduleExQuotes.forEach(module => {
			this.$moduleExQuotesElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleExQuotes.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleExQuotesElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.moduleExQuotes = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleExQuotes[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleExQuotesElements[index], { clearProps: true });
			}
        });
    
        this.moduleExQuotes.addLabel('step1');
        this.moduleExQuotes.to(this.$moduleExQuotes[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleExQuotes.to(this.$moduleExQuotesElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default AnimationExQuotes;
